import {
	writable,
} from 'svelte/store';


function createAlert() {
	const init = {value: null, className: null};

	const {
		subscribe,
		set,
	} = writable({...init});

	let timer;

	return {
		set,
		subscribe,
		setWithTimeout: ({value, className="is-danger", timeout=10000}) => {
			if (timer) clearTimeout(timer);
			
			set({value, className});
			timer = setTimeout(() => {
				set(init);
				clearTimeout(timer);
				timer = null;
			}, timeout);
		},
		clear: () => {
			if (timer) clearTimeout(timer);
			set(init);
		},
	}
}

export const alert = createAlert();

// This is for keeping PHP_DATA variables
// And would be set in entry point 
export const PHP = writable({});

export const notificationsList = writable([]);

function createNotification() {
	const initValue = {
		title: '',
		content: '',
		action: {
			value: '',
			url: '',
		},
		buttons: [],
		iconUrl: '',
		imageUrl: '',
	};

	const {
		subscribe,
		set,
		update
	} = writable({
		...initValue
	});

	return {
		set,
		subscribe,
		update: (key, value) => update(n => {
			n[key] = value;
			return n;
		}),
		updateAction: (key, value) => update(n => {
			n['action'][key] = value;
			return n;
		}),
		reset: () => set({...initValue}),
	};
}

export const notification = createNotification();